import React from "react";
import compose from "lodash/fp/compose";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { convertMutationErrors } from "../shared/util/graphql";
import { meQuery } from "../shared/LayoutDefault";

import UserView from "./ui/UserView";

const setQuery = gql`
  {
    licenseSet {
      id
      name
    }
    userSet {
      id
      username
      email
      mobilePhone
      isAdmin
      licenseId
    }
  }
`;

const createMutation = gql`
  mutation($input: CreateUserInput!) {
    create: createUser(input: $input) {
      user {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const updateMutation = gql`
  mutation($input: UpdateUserInput!) {
    update: updateUser(input: $input) {
      user {
        id
        username
      }
      errors {
        key
        message
      }
    }
  }
`;

const updatePasswordMutation = gql`
  mutation($input: UpdateUserPasswordInput!) {
    updatePassword: updateUserPassword(input: $input) {
      user {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const deleteMutation = gql`
  mutation($input: DeleteUserInput!) {
    delete: deleteUser(input: $input) {
      user {
        id
      }
    }
  }
`;

class C extends React.Component {
  handleCreate = async (values) => {
    const { data, createMutation } = this.props;
    const result = await createMutation({ variables: { input: values } });
    const errors = result.data.create.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleUpdate = async ({ id, ...values }) => {
    const { data, updateMutation } = this.props;
    const result = await updateMutation({
      variables: { input: { ...values, id } },
    });
    const errors = result.data.update.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleUpdatePassword = async ({ id, ...values }) => {
    const { updatePasswordMutation } = this.props;
    const result = await updatePasswordMutation({
      variables: { input: { ...values, id } },
    });
    const errors = result.data.updatePassword.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
  };

  handleDelete = async ({ id }) => {
    const { data, deleteMutation } = this.props;
    await deleteMutation({ variables: { input: { id } } });
    await data.refetch();
  };

  render() {
    return (
      <UserView
        data={this.props.data}
        onCreate={this.handleCreate}
        onUpdate={this.handleUpdate}
        onUpdatePassword={this.handleUpdatePassword}
        onDelete={this.handleDelete}
      />
    );
  }
}

const UserScene = compose(
  graphql(createMutation, { name: "createMutation" }),
  graphql(updateMutation, {
    name: "updateMutation",
    options: { refetchQueries: [{ query: meQuery }] },
  }),
  graphql(updatePasswordMutation, { name: "updatePasswordMutation" }),
  graphql(deleteMutation, { name: "deleteMutation" }),
  graphql(setQuery, { options: { fetchPolicy: "network-only" } })
)(C);

export default UserScene;
